const React = require('react');

const Content = require('../common/Content.jsx');
const _Signature = require('../common/Signature.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region V1

function SignatureV1(props) {
    const data = props.data || {};
    let includes = {};
    if (props.config && props.config.Config && props.config.Config.Includes) {
        includes = props.config.Config.Includes;
    }
    let statusIncluded = false;
    switch (data.Status) {
        case 1:
            statusIncluded = includes.Open;
            break;
        case 2:
            statusIncluded = includes.OnApproval;
            break;
        case 3:
            statusIncluded = includes.Closed;
            break;
        case 4:
            statusIncluded = includes.Declined;
            break;
    }
    if (!props.builder && !statusIncluded) {
        return null;
    }
    return <_Signature.V1.Component {...props} />
}

const TypeConfigV1 = {
    panel: {
        ..._Signature.V1.TypeConfig.panel,
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Date', name: 'Date', type: 'checkbox', value: true },
                    { display: 'Invoice Status', id: 'invoiceStatusProps', type: 'header' },
                    { display: 'Open', name: 'Open', type: 'checkbox', value: false },
                    { display: 'On Approval', name: 'OnApproval', type: 'checkbox', value: true },
                    { display: 'Closed', name: 'Closed', type: 'checkbox', value: false },
                    { display: 'Declined', name: 'Declined', type: 'checkbox', value: false }
                ]
            };
        }
    }
}

// #endregion V1

// #region V2

function SignatureV2(props) {
    const data = props.data || {};
    let statusIncluded = false;
    if (props.config && props.config.config) {
        let blockProps = {};
        if (props.config.config.Block) {
            blockProps = props.config.config.Block;
            switch (data.Status) {
                case 1:
                    statusIncluded = blockProps.open;
                    break;
                case 2:
                    statusIncluded = blockProps.approval;
                    break;
                case 3:
                    statusIncluded = blockProps.closed;
                    break;
                case 4:
                    statusIncluded = blockProps.declined;
                    break;
            }
        }
    }

    if (!props.builder && !statusIncluded) {
        return null;
    }
    return <_Signature.V2.Component {...props} />
}

const TypeConfigV2 = {
    panel: {
        block: () => {
            const blockConfig = _Signature.V2.TypeConfig.panel.block();
            const group = blockConfig.group;
            blockConfig.options.splice(2, 0,
                {
                    fullWidth: true,
                    group,
                    type: 'info',
                    value: 'Show Signature For Status:'
                },
                {
                    display: 'Open',
                    group,
                    name: 'open',
                    type: 'checkbox',
                    value: false
                },
                {
                    display: 'On Approval',
                    group,
                    name: 'approval',
                    type: 'checkbox',
                    value: true
                },
                {
                    display: 'Closed',
                    group,
                    name: 'closed',
                    type: 'checkbox',
                    value: false
                },
                {
                    display: 'Declined',
                    group,
                    name: 'declined',
                    type: 'checkbox',
                    value: false
                }
            );
            return blockConfig;
        },
        description: _Signature.V2.TypeConfig.panel.description,
        label: _Signature.V2.TypeConfig.panel.label,
        style: _Signature.V2.TypeConfig.panel.style,
        value: _Signature.V2.TypeConfig.panel.value
    }
}

// #endregion V2

module.exports = {
    V2: {
        Component: SignatureV2,
        TypeConfig: TypeConfigV2
    },

    // LEGACY
    V1: {
        Component: SignatureV1,
        TypeConfig: TypeConfigV1
    }
};